import restClient from "../restClient";

const endpoint = "/flags";

export const getFlags = async (module, options = {}) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { page, pageSize, search } = options || {};
    const params = {};
    if (module) params.type = module;
    if (page != null) params.page = page;
    if (pageSize != null) params.pageSize = pageSize;
    if (search) params.search = search;
    const response = await restClient.get(endpoint, { ...config, params });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const createFlag = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(endpoint, { data }, config);
    return response.data;
  } catch (err) {
    throw err;
  }
};


export const createDealFlag = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(`deal-flags`, { data }, config);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const updateFlag = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`${endpoint}/${id}`, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const deleteFlag = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`${endpoint}/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
}; 